module.exports = __webpack_public_path__ + "img/inst-5.38302ae6.png";